import { useEffect } from "react";
import userManager from "../util/userManager";
import { connect } from "react-redux";
import { AppDispatch, RootState } from "../app/store";
import Loader from "../components/widgets/Loader";
import { useAppDispatch } from "../app/hooks";
import { push } from "connected-react-router";
import { useLocation } from "react-router";

const Login = (props: any) => {
    const { oidc_user } = props;
    const location = useLocation();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (location.pathname === "/logout") {
            userManager.signoutRedirect();
        } else if (oidc_user) {
            if (location.pathname === "/callback") {
                dispatch(push("/"));
            } else {
                dispatch(push(location.pathname));
            }
        } else {
            userManager.signinRedirect();
        }
    }, [oidc_user]);

    return (
        <div className="h-screen flex overflow-hidden bg-primary text-primary">
            <Loader />
        </div>
    );
};

function mapStateToProps(state: RootState) {
    return {
        oidc_user: state.oidc.user,
    };
}

function mapDispatchToProps(dispatch: AppDispatch) {
    return {
        dispatch,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
